import Giveaway from '../features/giveaway/components/Giveaway';

const GiveawayPage = () => {
  return <Giveaway />;
};

export default GiveawayPage;
